import * as z from "zod";

export const detectDivergentCheckoutParcelPaths = {
  name: "detectDivergentCheckoutParcelPaths" as const,

  input: z.null(),

  output: z.object({ hasDivergentPaths: z.boolean() }),
};
